module.exports = __webpack_public_path__ + "img/songrong.64d754b4.jpg";